/* Ascend SM-900 LP — Montreal Weights
   Interactivity: hero carousel · One Machine exercise selector + per-exercise
   image carousel · exercise video carousel (click-to-play, one at a time) ·
   bundle builder · FAQ · photos/video toggle · sticky CTA.
   Multi-instance safe: everything scoped to each .mw900 root, class-based, no
   hardcoded data (all content comes from what Liquid rendered).            */
(function () {
  'use strict';
  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function q(root, sel) { return root.querySelector(sel); }

  function omArrow(cls) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'om-arrow ' + cls;
    b.setAttribute('aria-label', cls === 'prev' ? 'Previous image' : 'Next image');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="' +
      (cls === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6') + '"/></svg>';
    return b;
  }

  /* ---- Hero carousel (dots built from slide count) ---- */
  function heroCarousel(root) {
    var car = q(root, '.js-hero-carousel'); if (!car) return;
    var track = car.querySelector('.carousel-track'); if (!track) return;
    var dotsWrap = car.querySelector('.car-dots');
    var n = track.children.length, i = 0, dots = [];
    if (dotsWrap && n > 1) {
      for (var d = 0; d < n; d++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'car-dot';
        b.setAttribute('aria-label', 'Show image ' + (d + 1));
        if (d === 0) b.setAttribute('aria-current', 'true');
        (function (idx) { b.addEventListener('click', function () { go(idx); }); })(d);
        dotsWrap.appendChild(b); dots.push(b);
      }
    }
    function go(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (t, x) { t.setAttribute('aria-current', x === i ? 'true' : 'false'); });
    }
    var nx = car.querySelector('.car-arrow.next'), pv = car.querySelector('.car-arrow.prev');
    if (nx) nx.addEventListener('click', function () { go(i + 1); });
    if (pv) pv.addEventListener('click', function () { go(i - 1); });
    var x0 = null;
    car.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    car.addEventListener('pointerup', function (e) { if (x0 === null) return; var dx = e.clientX - x0; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); x0 = null; });
    go(0);
  }

  /* ---- One Machine: exercise selector + per-exercise image carousel ----
     Feature card shows the active exercise's image carousel (arrows on desktop,
     swipe + dots on touch); the grid (desktop) / rail (mobile) selects which
     exercise is active and updates the dark name bar + mobile progress dots. */
  function omSelector(root) {
    var om = q(root, '[data-om]'); if (!om) return;
    var feature = q(om, '.om-feature');
    var galleries = feature ? qa(feature, '.om-gallery') : [];
    var cards = qa(om, '.om-card');
    var dotsWrap = q(om, '.om-dots');
    var nameEl = q(om, '.js-om-name'), musEl = q(om, '.js-om-muscles');
    var mqMobile = window.matchMedia ? window.matchMedia('(max-width:600px)') : null;

    /* per-exercise image carousel */
    galleries.forEach(function (g) {
      var track = g.querySelector('.om-slides'); if (!track) return;
      var slides = track.children, idx = 0;
      if (slides.length <= 1) return;
      var prev = omArrow('prev'), next = omArrow('next');
      g.appendChild(prev); g.appendChild(next);
      var dots = document.createElement('div'); dots.className = 'om-idots';
      for (var di = 0; di < slides.length; di++) {
        var dd = document.createElement('button'); dd.type = 'button'; dd.className = 'om-idot';
        dd.setAttribute('aria-label', 'Image ' + (di + 1));
        if (di === 0) dd.setAttribute('aria-current', 'true');
        (function (n2) { dd.addEventListener('click', function () { go(n2); }); })(di);
        dots.appendChild(dd);
      }
      g.appendChild(dots);
      var go = function (k) {
        idx = (k + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        var dc = dots.children; for (var j = 0; j < dc.length; j++) dc[j].setAttribute('aria-current', j === idx ? 'true' : 'false');
      };
      prev.addEventListener('click', function () { go(idx - 1); });
      next.addEventListener('click', function () { go(idx + 1); });
      var x0 = null;
      g.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
      g.addEventListener('pointerup', function (e) { if (x0 === null) return; var dx = e.clientX - x0; if (Math.abs(dx) > 40) go(dx < 0 ? idx + 1 : idx - 1); x0 = null; });
    });

    /* mobile progress dots (one per exercise) */
    var pdots = [];
    if (dotsWrap && cards.length > 1) {
      cards.forEach(function (c, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'om-dot';
        b.setAttribute('aria-label', 'Exercise ' + (i + 1));
        if (i === 0) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', function () { activate(i, true); });
        dotsWrap.appendChild(b); pdots.push(b);
      });
    }

    function activate(i, scrollRail) {
      cards.forEach(function (c, j) {
        var on = j === i;
        c.classList.toggle('on', on);
        c.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      galleries.forEach(function (g) { g.classList.toggle('on', parseInt(g.dataset.i, 10) === i); });
      pdots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      var card = cards[i]; if (!card) return;
      if (nameEl) nameEl.textContent = card.getAttribute('data-name') || '';
      if (musEl) musEl.textContent = card.getAttribute('data-muscles') || '';
      if (scrollRail && card.scrollIntoView && mqMobile && mqMobile.matches) {
        card.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      }
    }
    cards.forEach(function (c, i) { c.addEventListener('click', function () { activate(i, true); }); });
  }

  /* ---- Exercise video carousel: click-to-play, only one plays at a time ---- */
  function omVideos(root) {
    var sec = q(root, '[data-omvid]'); if (!sec) return;
    var rail = q(sec, '.omv-rail'); if (!rail) return;
    var cards = qa(rail, '.omv-card');
    var vids = qa(rail, '.omv-video');

    function stopOthers(except) {
      vids.forEach(function (v) {
        if (v === except) return;
        if (!v.paused) { try { v.pause(); } catch (e) {} }
        try { v.currentTime = 0; } catch (e) {}
        var c = v.closest ? v.closest('.omv-card') : null; if (c) c.classList.remove('playing');
      });
    }
    cards.forEach(function (card) {
      var v = card.querySelector('.omv-video'); if (!v) return;
      var btn = card.querySelector('.omv-play');
      if (btn) btn.addEventListener('click', function () {
        stopOthers(v); card.classList.add('playing');
        var pr = v.play && v.play(); if (pr && pr.catch) pr.catch(function () {});
      });
      v.addEventListener('play', function () { stopOthers(v); card.classList.add('playing'); });
      v.addEventListener('ended', function () { card.classList.remove('playing'); try { v.currentTime = 0; } catch (e) {} });
    });

    var prev = q(sec, '.omv-arrow.prev'), next = q(sec, '.omv-arrow.next');
    function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8; }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });

    var dotsWrap = q(sec, '.omv-dots'); var dots = [];
    if (dotsWrap && cards.length > 1) {
      cards.forEach(function (c, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'omv-dot';
        b.setAttribute('aria-label', 'Go to video ' + (i + 1));
        if (i === 0) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', function () { c.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); });
        dotsWrap.appendChild(b); dots.push(b);
      });
    }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
      if (dots.length) {
        var railLeft = rail.getBoundingClientRect().left, best = 0, bestD = Infinity;
        cards.forEach(function (c, i) { var d = Math.abs(c.getBoundingClientRect().left - railLeft); if (d < bestD - 1) { bestD = d; best = i; } });
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === best ? 'true' : 'false'); });
      }
    }
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  }

  /* ---- Build Your Setup: tiers drive the summary panel ----
     Desktop: vertical list of tiers beside a sticky product card (unchanged).
     Mobile (<=600px): tiers relocate INTO the product card (below the price);
     the selected tier becomes a compact full-width bar with a highlighted
     chevron, and the other tiers collapse into a 2-up grid that expands on tap. */
  function bundle(root) {
    var builder = q(root, '.builder'); if (!builder) return;
    var tiersEl = q(builder, '.tiers'); if (!tiersEl) return;
    var tiers = qa(tiersEl, '.tier'); if (!tiers.length) return;
    var slot = q(builder, '.tier-slot');
    var origParent = tiersEl.parentNode, origNext = tiersEl.nextSibling; // restore point (before .summary)
    var sumNm = q(builder, '.js-sum-nm'), sumNow = q(builder, '.js-sum-now'),
        sumWas = q(builder, '.js-sum-was'), sumImg = q(builder, '.js-sum-img'),
        sumInc = q(builder, '.js-sum-inc'), sumRate = q(builder, '.js-sum-rate'),
        sumCta = q(builder, '.js-sum-cta'), summary = q(builder, '.summary');
    var mq = window.matchMedia ? window.matchMedia('(max-width:600px)') : null;
    var altsEl = null;
    function isMobile() { return mq ? mq.matches : (window.innerWidth <= 600); }

    /* On mobile the card image/price swap on selection; if the card is scrolled
       off-screen when a tier is chosen, bring it into view. */
    function revealCard() {
      if (!summary || !window.matchMedia || !window.matchMedia('(max-width:740px)').matches) return;
      var r = summary.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.top < 0 || r.bottom > vh) {
        try { summary.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        catch (e) { summary.scrollIntoView(); }
      }
    }

    /* Mobile layout: selected tier = bar (first child), the rest live in .tier-alts. */
    function arrange() {
      if (!tiersEl.classList.contains('is-mobile')) return;
      var sel = tiersEl.querySelector('.tier[aria-pressed="true"]') || tiers[0];
      if (!altsEl) { altsEl = document.createElement('div'); altsEl.className = 'tier-alts'; }
      tiersEl.insertBefore(sel, tiersEl.firstChild);        // selected on top
      tiersEl.insertBefore(altsEl, sel.nextSibling);        // alts directly under it
      tiers.forEach(function (t) { if (t !== sel && t.parentNode !== altsEl) altsEl.appendChild(t); });
    }
    function closeDrop() {
      tiersEl.classList.remove('is-open');
      var sel = tiersEl.querySelector('.tier[aria-pressed="true"]');
      if (sel) sel.setAttribute('aria-expanded', 'false');
    }
    function toMobile() {
      if (slot) slot.appendChild(tiersEl);
      tiersEl.classList.add('is-mobile');
      arrange();
    }
    function toDesktop() {
      tiersEl.classList.remove('is-mobile', 'is-open');
      tiers.forEach(function (t) { t.removeAttribute('aria-expanded'); tiersEl.appendChild(t); }); // flatten, original order
      if (altsEl && altsEl.parentNode) altsEl.parentNode.removeChild(altsEl);
      if (origNext && origNext.parentNode === origParent) origParent.insertBefore(tiersEl, origNext);
      else origParent.appendChild(tiersEl);
    }
    function layout() { if (isMobile()) toMobile(); else toDesktop(); }

    function pick(t, userAction) {
      tiers.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
      if (sumNm) sumNm.textContent = t.getAttribute('data-nm') || '';
      if (sumNow) sumNow.textContent = t.getAttribute('data-now') || '';
      if (sumWas) sumWas.textContent = t.getAttribute('data-was') || '';
      if (sumRate) sumRate.textContent = t.getAttribute('data-rate') || '';
      var img = t.getAttribute('data-img'); if (sumImg && img) sumImg.setAttribute('src', img);
      var url = t.getAttribute('data-url'); if (sumCta && url) sumCta.setAttribute('href', url);
      if (sumInc) {
        sumInc.textContent = '';
        var inc = [], holder = t.querySelector('.tier-inc');
        if (holder) { try { inc = JSON.parse(holder.textContent); } catch (e) { inc = []; } }
        var isBase = t.hasAttribute('data-base');
        inc.forEach(function (line, idx) {
          var li = document.createElement('li');
          li.className = 'new' + (idx === inc.length - 1 && !isBase ? ' added' : '');
          var m = document.createElement('span'); m.className = 'm';
          var s = document.createElement('span');
          if (idx === inc.length - 1 && !isBase) { var bEl = document.createElement('b'); bEl.textContent = line; s.appendChild(bEl); }
          else { s.textContent = line; }
          li.appendChild(m); li.appendChild(s); sumInc.appendChild(li);
        });
      }
      if (tiersEl.classList.contains('is-mobile')) { arrange(); closeDrop(); }
      if (userAction) revealCard();
    }

    /* One delegated handler survives the DOM relocation. On mobile, tapping the
       already-selected bar toggles the dropdown; any other tap selects. */
    tiersEl.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('.tier') : null;
      if (!t || !tiersEl.contains(t)) return;
      if (tiersEl.classList.contains('is-mobile') && t.getAttribute('aria-pressed') === 'true') {
        var open = tiersEl.classList.toggle('is-open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }
      pick(t, true);
    });

    var pre = tiersEl.querySelector('.tier[data-preselect="true"]') || tiers[0];
    layout();
    pick(pre, false);
    if (mq && mq.addEventListener) mq.addEventListener('change', layout);
    else if (mq && mq.addListener) mq.addListener(layout);
  }

  /* ---- FAQ accordion ---- */
  function faq(root) {
    qa(root, '.faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var it = this.closest('.faq-item'); if (!it) return;
        var open = it.classList.contains('open');
        qa(root, '.faq-item').forEach(function (x) { x.classList.remove('open'); });
        if (!open) it.classList.add('open');
      });
    });
  }

  /* ---- See It In Detail: Photos / Video toggle ---- */
  function detailToggle(root) {
    var btns = qa(root, '.dt-btn'); if (!btns.length) return;
    var views = qa(root, '.detail-views .dv');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = this.dataset.view;
        btns.forEach(function (b) { b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
        views.forEach(function (dv) { dv.classList.toggle('on', dv.dataset.view === v); });
      });
    });
  }

  /* ---- Fit Check: kg <-> lbs unit toggle (converts all kg copy in the section) ---- */
  function fitUnits(root) {
    var tgl = q(root, '.js-unit-toggle'); if (!tgl) return;
    var section = tgl.closest('section'); if (!section) return;
    var btns = qa(tgl, '.ut-btn'); if (!btns.length) return;
    var kgLabel = 'kg', lbLabel = 'lbs';
    btns.forEach(function (b) { if (b.dataset.unit === 'kg') kgLabel = (b.textContent || 'kg').trim(); else lbLabel = (b.textContent || 'lbs').trim(); });

    /* wrap every "<number> kg" occurrence in the section (skip the toggle itself) */
    var probe = /(\d[\d,]*(?:\.\d+)?)(\s*)kg\b/i;
    var walker = document.createTreeWalker(section, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || !probe.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        if (tgl.contains(n)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var targets = [], t; while ((t = walker.nextNode())) targets.push(t);
    var rx = /(\d[\d,]*(?:\.\d+)?)(\s*)kg\b/gi;
    targets.forEach(function (node) {
      var frag = document.createDocumentFragment(), str = node.nodeValue, last = 0, m; rx.lastIndex = 0;
      while ((m = rx.exec(str))) {
        if (m.index > last) frag.appendChild(document.createTextNode(str.slice(last, m.index)));
        var span = document.createElement('span');
        span.className = 'js-wt';
        span.setAttribute('data-kg', m[1].replace(/,/g, ''));
        span.setAttribute('data-sp', m[2] || ' ');
        span.textContent = m[0];
        frag.appendChild(span);
        last = m.index + m[0].length;
      }
      if (last < str.length) frag.appendChild(document.createTextNode(str.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });

    var spans = qa(section, '.js-wt');
    function comma(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function render(unit) {
      spans.forEach(function (sp) {
        var kg = parseFloat(sp.getAttribute('data-kg')), sep = sp.getAttribute('data-sp') || ' ';
        if (unit === 'lb') sp.textContent = comma(Math.round(kg * 2.20462)) + sep + lbLabel;
        else sp.textContent = comma(kg) + sep + kgLabel;
      });
    }
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        render(btn.dataset.unit);
      });
    });
    render('kg');
  }

  /* ---- Sticky CTA reveals after hero ---- */
  function stickyAtc(root) {
    var atc = q(root, '.atc'), hero = q(root, '.hero'); if (!atc || !hero) return;
    if (!('IntersectionObserver' in window)) { atc.classList.add('show'); return; }
    new IntersectionObserver(function (e) { atc.classList.toggle('show', !e[0].isIntersecting); }, { threshold: 0 }).observe(hero);
  }

  /* ---- Floating section nav: reveal after hero + smooth-scroll + scrollspy ---- */
  function navPill(root) {
    var pill = q(root, '.mw-navpill'); if (!pill) return;
    var links = qa(pill, '.np-link');
    var inner = q(pill, '.np-inner');
    /* resolve a link to its section: prefer the #id, else a fallback selector for the
       matching module — so the nav still works if an id is missing or the section moved */
    var FALLBACK = { lifts: '[data-om], [data-omvid]', fit: '.fitcheck', shop: '.builder', reviews: '#reviews' };
    function resolve(a) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return null;
      var key = href.slice(1);
      var el = document.getElementById(key);
      if (!el && FALLBACK[key]) el = root.querySelector(FALLBACK[key]) || document.querySelector(FALLBACK[key]);
      return el;
    }
    var targets = links.map(resolve);
    /* a link is "live" if it resolves to an on-page section OR it's an external/PDP link
       (a non-empty href that isn't an in-page anchor, e.g. the Buy Now pill set to go to
       the product page). Hide only DEAD in-page anchors so external links stay clickable. */
    var isExternal = function (a) { var h = a.getAttribute('href') || ''; return h.length > 0 && h.charAt(0) !== '#'; };
    var live = links.map(function (a, i) { return !!targets[i] || isExternal(a); });
    links.forEach(function (a, i) { if (!live[i]) a.style.display = 'none'; });
    if (!live.some(Boolean)) { pill.style.display = 'none'; return; }

    function headerOffset() {
      var h = document.querySelector('sticky-header, .section-header, .header-wrapper, #shopify-section-header, header[role="banner"]');
      if (h) { var r = h.getBoundingClientRect(); var pos = window.getComputedStyle(h).position;
        if ((pos === 'fixed' || pos === 'sticky') && r.height && r.top < 60) return r.height + 8; }
      return 80;
    }

    /* reveal: show the pill only once the active hero — the desktop hero, or (when it's
       hidden on mobile A/B) the Mobile Hero v2 section — has scrolled fully above the fold.
       Computed from the hero's live rect on EVERY scroll frame (see the rAF loop below)
       rather than via IntersectionObserver: iOS momentum/fast scrolling can drop IO
       callbacks, which left the pill stuck visible when scrolling back up into the hero.
       A per-frame rect read is self-correcting — the next scroll event always fixes state. */
    var visible = function (el) { return el && window.getComputedStyle(el).display !== 'none'; };
    function revealTarget() {
      var h = q(root, '.hero');
      if (visible(h)) return h;
      var m = document.querySelector('.mw-mobile-hero-v2');
      return visible(m) ? m : null;
    }
    var watch = revealTarget();
    function updateShow() {
      var t = watch, show;
      if (t) show = t.getBoundingClientRect().bottom <= 4;          // hero fully above the fold
      else show = (window.pageYOffset || 0) > (window.innerHeight * 0.8); // no hero found → threshold
      pill.classList.toggle('show', show);
    }
    /* re-resolve which hero to watch when the viewport flips desktop⇄mobile */
    window.addEventListener('resize', function () { watch = revealTarget(); updateShow(); }, { passive: true });

    /* Spamming the nav used to stack 5–6 overlapping smooth-scrolls → a multi-second
       flood of scroll events that thrashes the theme's broken scroll handler (the P0
       "observer is not defined" bug fires on every scroll frame) and can hang the tab.
       Lock to ONE scroll per burst: ignore taps while a programmatic scroll is in flight. */
    /* Spamming the nav used to stack 5–6 overlapping smooth-scrolls → a multi-second flood of
       scroll events. Every scroll listener on the page (our spy(), plus the theme + apps like
       ContentSquare/Clarity/Rebuy) runs on each event, and the stacked storm saturates the main
       thread → the page goes unresponsive. Lock to ONE scroll at a time: drop taps while a scroll
       is in flight, and unlock on the real scrollend (timer fallback for browsers without it). */
    var navBusy = false, navTimer = 0;
    function navUnlock() { navBusy = false; if (navTimer) { clearTimeout(navTimer); navTimer = 0; } }
    links.forEach(function (a, i) {
      a.addEventListener('click', function (ev) {
        var href = a.getAttribute('href') || '';
        var inPage = href.charAt(0) === '#';
        var t = targets[i] || resolve(a);
        if (!t) { if (inPage) ev.preventDefault(); return; } // dead #anchor → swallow it, never fall through to theme
        ev.preventDefault();
        if (navBusy) return;                                 // a scroll is already running → drop the extra taps
        navBusy = true;
        window.addEventListener('scrollend', navUnlock, { once: true });
        navTimer = window.setTimeout(navUnlock, 1200);       // fallback: Safari <17 / older browsers
        var y = t.getBoundingClientRect().top + window.pageYOffset - headerOffset();
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });

    function spy() {
      var mid = window.innerHeight * 0.4, best = -1, bestTop = -Infinity;
      targets.forEach(function (t, i) {
        if (!t || links[i].classList.contains('np-buy')) return;
        var top = t.getBoundingClientRect().top - 80;
        if (top <= mid && top > bestTop) { bestTop = top; best = i; }
      });
      links.forEach(function (a, i) {
        var on = (i === best && !a.classList.contains('np-buy'));
        a.classList.toggle('is-active', on);
        if (on && inner) { var l = a.offsetLeft - (inner.clientWidth - a.clientWidth) / 2; try { inner.scrollTo({ left: l, behavior: 'smooth' }); } catch (e) { inner.scrollLeft = l; } }
      });
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return; ticking = true;
      window.requestAnimationFrame(function () { updateShow(); spy(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    updateShow(); spy();
  }

  /* ---- Build Your Setup: "Buy Now" adds the selected tier to cart (drawer / cart / checkout) ---- */
  function buyNow(root) {
    var btn = q(root, '.js-sum-buy'); if (!btn) return;
    var tiersEl = q(root, '.tiers');

    function variantId() {
      var sel = tiersEl ? tiersEl.querySelector('.tier[aria-pressed="true"]') : null;
      if (sel) { var m = (sel.getAttribute('data-url') || '').match(/variant=(\d+)/); if (m) return m[1]; }
      return btn.getAttribute('data-variant') || '';
    }

    function openCart() {
      var opened = false;
      /* Rebuy Smart Cart (this theme) — let it manage the drawer */
      if (window.Rebuy) {
        try { document.dispatchEvent(new CustomEvent('rebuy:cart.change')); } catch (e) {}
        var sc = window.Rebuy.SmartCart;
        if (sc) { try { (sc.show || sc.open || sc.toggleCart || function () {}).call(sc, true); } catch (e) {} }
        opened = true;
      }
      /* Dawn-style <cart-drawer> */
      var cd = document.querySelector('cart-drawer');
      if (!opened && cd && typeof cd.open === 'function') { try { cd.open(); opened = true; } catch (e) {} }
      /* generic drawer container */
      if (!opened) {
        var drawer = document.querySelector('#CartDrawer, #cart-drawer, .drawer--cart, .cart-drawer, .js-drawer--cart');
        if (drawer) { drawer.classList.add('is-open', 'active', 'open', 'animate'); document.documentElement.classList.add('cart-open'); opened = true; }
      }
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
      if (!opened) window.location.href = '/cart';               // nothing to open → cart page
    }

    btn.addEventListener('click', function () {
      var id = variantId(); if (!id) { window.location.href = '/cart'; return; }
      var action = btn.getAttribute('data-action') || 'drawer';
      if (action === 'checkout') { addThen(id, function () { window.location.href = '/checkout'; }); return; }
      if (action === 'cart') { addThen(id, function () { window.location.href = '/cart'; }); return; }
      addThen(id, openCart);
    });

    function addThen(id, done) {
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '.7';
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; done(); })
        .catch(function () { window.location.href = '/cart'; });
    }
  }

  function initSection(root) {
    heroCarousel(root); omSelector(root); omVideos(root); bundle(root); faq(root); fitUnits(root); detailToggle(root); stickyAtc(root); navPill(root); buyNow(root);
  }
  function init() { Array.prototype.slice.call(document.querySelectorAll('.mw900')).forEach(initSection); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
